import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';

import { ErrorBoundary } from '@salud-front/shared';
import IndexComponent from './components/lay.rutasServicios';

import './styles/index.less';

const root = ReactDOM.createRoot(document.getElementById('rutas-servicios'));
root.render(
  <StrictMode>
    <ErrorBoundary>
      <IndexComponent />
    </ErrorBoundary>
  </StrictMode>,
);
